import NotificationManager from "utils/notifications";

export const createValidationErrorHandler = (
  setSelectedTab,
  setSelectedLabel,
  tabLabels
) => {
  const showValidationErrors = (errors, setFieldTouched) => {
    const errorMessages = [];
    const errorTabs = new Set();
    let firstErrorField = null;

    const extractErrors = (obj, prefix = "") => {
      Object.keys(obj).forEach(key => {
        if (typeof obj[key] === "string") {
          errorMessages.push(obj[key]);
          const fieldPath = prefix ? `${prefix}${key}` : key;

          if (!firstErrorField) {
            firstErrorField = fieldPath;
          }

          let tabIndex = 0;
          if (
            fieldPath.startsWith("physician_information") ||
            fieldPath.startsWith("patient_insurances") ||
            fieldPath.startsWith("physicians")
          ) {
            tabIndex = 1;
          } else if (fieldPath.startsWith("patient_information")) {
            tabIndex = 0;
          }

          errorTabs.add(tabIndex);
        } else if (typeof obj[key] === "object" && obj[key] !== null) {
          extractErrors(obj[key], `${prefix}${key}.`);
        }
      });
    };

    extractErrors(errors);

    if (errorMessages.length > 0) {
      const firstErrorTab = Array.from(errorTabs)[0];
      const errorTabName = tabLabels[firstErrorTab];

      setSelectedTab(firstErrorTab);
      setSelectedLabel(errorTabName);

      NotificationManager.error(errorMessages[0], errorTabName, 5000);

      setTimeout(() => {
        const fieldName = firstErrorField.replace(/\./g, "_");
        const errorInput = document.querySelector(
          `[name="${fieldName}"], [name="${firstErrorField}"]`
        );
        if (errorInput) {
          if (setFieldTouched) {
            setFieldTouched(firstErrorField, true);
          }
          errorInput.focus();
          errorInput.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 300);
    }
  };

  return { showValidationErrors };
};
